import React, { useEffect, useState, useRef, useCallback } from "react";
import { Col, Row, Button, InputGroup, img } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";

// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditor from "react-froala-wysiwyg";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

import Loader from "../Loader/Loader";
import SideBar from "../SideBar/SideBar";
import TabsSection from "../Tabs/TabsSection";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { RegEx } from "../../Utils/RegEx";
import { SavePages } from "../API/MarketPlaceSetUp/SavePages";
import AddImage from "../../assets/AddImage.svg";
import swal from "sweetalert";
import { GetPageUrl } from "../API/MarketPlaceSetUp/GetPageUrl";
import { GetEditPagesData } from "../API/MarketPlaceSetUp/EditpagesData";
import { SaveEditPages } from "../API/MarketPlaceSetUp/EditPages";

// cropper
import Cropper from "react-easy-crop";
import Modal from "react-bootstrap/Modal";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import getCroppedImg from "./cropImage";
import NoDataText from "../NoDataText";
import BackButton from "../BackButton/BackButton";

const ViewPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // feild
  const [PageName, setPageName] = useState("");
  const [PageUrl, setPageUrl] = useState("");
  const [PageTitle, setPageTitle] = useState("");
  const [MetaDescription, setMetaDescription] = useState("");
  const [PageContent, setPageContent] = useState("");
  const [image, setImage] = useState(null);
  const inputRef = useRef();
  const [imageType, setimageType] = useState(null);

  // feild--Err
  const [PageNameErr, setPageNameErr] = useState("");
  const [PageUrlErr, setPageUrlErr] = useState("");
  const [imageErr, setImageErr] = useState(null);
  const [PageTitleErr, setPageTitleErr] = useState("");
  const [MetaDescriptionErr, setMetaDescriptionErr] = useState("");
  const [PageContentErr, setPageContentErr] = useState("");
  const { slug } = useParams();
  const getEditId = slug.split("=");

  const [cropImg, setcropImg] = useState("");

  useEffect(() => {
    setLoading(true);
    getEditData();
  }, []);

  const getEditData = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      page_id: parseInt(getEditId[1]),
      mms_city_id: parseInt(cityId),
    };
    const Response = await GetEditPagesData(data, () => {
      navigate("/");
    });
    if (Response.success == true) {
      setPageName(Response.data[0].page_name);
      setPageTitle(Response.data[0].page_title);
      setMetaDescription(Response.data[0].description);
      setPageContent(Response.data[0].page_content);
      setPageUrl(Response.data[0].page_internal_url);
      setcropImg(Response.data[0].page_image);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else if (Response.status === 429) {
      setLoading(true);
      swal({
        // title: "Error!",
        title: `${Response.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else {
      setLoading(false);
      swal({
        text: `${Response.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Pages</p>
          <div className="acc-dashboard mt-4 Marketplace">
            <TabsSection />

            <div className="viePage_editBtn">
              <p class="page-maintitle pt-2">View Page</p>
              <p class="page-subtitle"></p>
              <Link
                to={`/marketplace-setup/pages/edit-page/id=${getEditId[1]}`}
              >
                <div
                  variant="primary"
                  className="create-btn export-btn-main"
                  style={{ marginRight: 160, fontSize: 17 }}
                  // onClick={() => handleEdit()}
                >
                  Edit
                </div>
              </Link>
            </div>
            {/* start */}
            <Row>
              {/* <Col md="2"></Col> */}
              <Col md="10" style={{ marginLeft: "auto", marginRight: "auto" }}>
                <div
                  //   onSubmit={SaveHandler}
                  className="formmain mx-5 mt-4 signin-row profile-form pb-4"
                >
                  <Row>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page Name <span className="star-required"></span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            placeholder="Enter Page Name"
                            className="custom-formcontrol"
                            value={PageName}
                            // onChange={(e) => {
                            //   onChangeHandler("PageName", e.target.value);
                            // }}
                            // maxLength={10}
                          />
                        </InputGroup>
                        {PageNameErr && (
                          <p className="text-danger">{PageNameErr}</p>
                        )}
                        {/* // */}
                      </Form.Group>
                    </Col>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page URL <span className="star-required"></span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            placeholder="Enter Page URL"
                            className="custom-formcontrol"
                            value={PageUrl}
                            // onChange={(e) => {
                            //   onChangeHandler("PageUrl", e.target.value);
                            // }}
                          />
                        </InputGroup>
                        {PageUrlErr && (
                          <p className="text-danger">{PageUrlErr}</p>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page Title <span className="star-required"></span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            placeholder="Enter Page Title"
                            className="custom-formcontrol"
                            value={PageTitle}
                            // onChange={(e) => {
                            //   onChangeHandler("PageTitle", e.target.value);
                            // }}
                          />
                        </InputGroup>
                        {PageTitleErr && (
                          <p className="text-danger">{PageTitleErr}</p>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Meta description{" "}
                          <span className="star-required"></span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            placeholder="Enter Meta Description"
                            className="custom-formcontrol"
                            value={MetaDescription}
                            // onChange={(e) => {
                            //   onChangeHandler(
                            //     "MetaDescription",
                            //     e.target.value
                            //   );
                            // }}
                          />
                        </InputGroup>
                        {MetaDescriptionErr && (
                          <p className="text-danger">{MetaDescriptionErr}</p>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="12" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page Banner <span className="star-required"></span>
                        </Form.Label>

                        <div
                          className="upload_main_banner"
                          // onClick={triggerFileSelectPopup}
                        >
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputRef}
                            style={{ display: "none" }}
                            // onChange={handleSetCropperImg}
                            onClick={(e) => (e.target.value = null)}
                          />
                          {cropImg == "" ? (
                            <>
                              <div
                                className="page_img"
                                style={{ padding: image == null ? 20 : 0 }}
                              >
                                <img src={AddImage} />
                                <p class="noData">{NoDataText.ErrText}</p>
                              </div>
                            </>
                          ) : (
                            <div style={{ cursor: "default" }}>
                              <img
                                src={cropImg}
                                className="BannerImgStore"
                                style={{ cursor: "default" }}
                              />

                              {/* {ShowEditBtn && (
                        <button
                        className="green-btn btn btn-primary edit_hover_buttons"
                        style={{width:135,opacity:1,zIndex:9999}}
                        >
                        Edit Picture
                        </button>
                     )} */}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md="12" className="">
                      <Form.Group className="mt-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page Content <span className="star-required"></span>
                        </Form.Label>
                        <div className="p-3 page_cont">
                          <FroalaEditorView model={PageContent} />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            {/* end */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPage;
